// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__20NyY","box":"Profile_box__z7Bq-"};